import React from 'react';

/**
 * One chip per merge field. Clicking inserts `{{field}}` so users never type
 * braces (and never type the single-brace form that ships literally).
 */
const MergeFieldChips: React.FC<{
  fields: readonly string[];
  onInsert: (token: string) => void;
  disabled?: boolean;
}> = ({ fields, onInsert, disabled }) => (
  <div className="flex flex-wrap items-center gap-2">
    <span className="text-xs text-gray-400">Insert:</span>
    {fields.map((f) => (
      <button
        key={f}
        type="button"
        disabled={disabled}
        // Keep focus (and the caret) in the field being edited.
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => onInsert(`{{${f}}}`)}
        className="rounded-full border border-gray-600 bg-gray-900 px-2 py-0.5 font-mono text-xs text-gray-300 hover:border-blue-500 hover:text-blue-200 disabled:opacity-50"
      >
        {`{{${f}}}`}
      </button>
    ))}
  </div>
);

export default MergeFieldChips;
